import initVueApp from "@/core.js";
const component = require(`./../views/ResetPassword.vue`).default;
initVueApp(component);
